import v1 from './v1/index.js';
import v2 from './v2/index.js';
export { ContentSourceType, ContentType, DrmQuality } from './types.js';
import './v1/asset.js';
import './v1/shows.js';
import './v1/streaming.js';
import './v2/live.js';

function content(backendAxiosInstance) {
  return {
    v1: v1(backendAxiosInstance),
    v2: v2(backendAxiosInstance)
  };
}

export { content as default };
//# sourceMappingURL=index.js.map
